@for (button of buttons(); track button.dimension) {
<button
  type="button"
  zagButton="icon"
  zagSize="sm"
  class="zag-dropdown-sort-actions__button"
  [attr.data-dimension]="button.dimension"
  [attr.aria-label]="button.label"
  [attr.aria-pressed]="button.pressed"
  [zagTooltip]="button.label"
  (click)="toggle(button.dimension, $event)"
>
  <span [zagIcon]="button.icon" aria-hidden="true"></span>
  <span [zagIcon]="button.directionIcon" class="zag-dropdown-sort-actions__addon" aria-hidden="true"></span>
</button>
}
